import { render, staticRenderFns } from "./FtaInfo.vue?vue&type=template&id=553c4c1f&scoped=true"
import script from "./FtaInfo.vue?vue&type=script&lang=js"
export * from "./FtaInfo.vue?vue&type=script&lang=js"
import style0 from "../fta.css?vue&type=style&index=0&id=553c4c1f&prod&scoped=true&lang=css&external"
import style1 from "./FtaInfo.less?vue&type=style&index=1&id=553c4c1f&prod&lang=less&scoped=true&external"
import style2 from "./FtaInfo.vue?vue&type=style&index=2&id=553c4c1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c4c1f",
  null
  
)

export default component.exports